/* eslint-disable react/require-default-props */
import {
  Container,
  ExpandLessIcon,
  ExpandMoreIcon,
  Heading,
} from 'elmo-elements';
import * as React from 'react';
import { ReactNode, useState } from 'react';
import './layoutSection.scss';

const CLASSNAME_PREFIX = 'layout-section';
export interface LayoutSectionPropsType {
  /** The content of a icon */
  children?: ReactNode | string;
  /** Add custom class to class attribute */
  className?: string;
}

export interface LayoutSectionSubcompPropsType {
  isOpen: boolean;
  isCollapsible: boolean;
  /** The content of a icon */
  children?: ReactNode | string;
}

interface LayoutComponentPropsType {
  heading?: ReactNode | string;
  content?: ReactNode | string;
  isCollapsible?: boolean;
  className?: string;
  /** to remove spacing above its margin/padding and padding in heading so it looks consistent  */
  isFirst?: boolean;
}

const LayoutSection = ({
  children,
  className,
}: LayoutSectionPropsType): React.ReactElement => (
  <div className={`${CLASSNAME_PREFIX}__wrapper ${className}`}>
    <div className={`${CLASSNAME_PREFIX}`}>{children}</div>
  </div>
);

const showExpandIcon = (isOpen: boolean): React.ReactElement =>
  isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />;

const LayoutSectionHeader = ({
  children,
  isOpen,
  isCollapsible,
}: LayoutSectionSubcompPropsType): React.ReactElement => (
  <Heading
    htmlTag="h3"
    size="rg"
    className={`${CLASSNAME_PREFIX}__header ${
      isCollapsible ? 'cursor-pointer' : ''
    }`}
  >
    {children}
    {isCollapsible && showExpandIcon(isOpen)}
  </Heading>
);

const LayoutSectionContent = ({
  children,
  isOpen,
  isCollapsible,
}: LayoutSectionSubcompPropsType): React.ReactElement => (
  <div className={`${CLASSNAME_PREFIX}__content`}>
    <div
      className={`${CLASSNAME_PREFIX}__content-inner ${
        isOpen || !isCollapsible ? 'is-open' : 'is-closed'
      }`}
    >
      {children}
    </div>
  </div>
);

const LayoutSectionComponent = ({
  heading,
  content,
  isCollapsible = false,
  className,
  isFirst = false,
}: LayoutComponentPropsType): React.ReactElement => {
  const [isContentOpen, setIsContentOpen] = useState<boolean>(false);

  return (
    <div
      className={`${CLASSNAME_PREFIX}__wrapper ${
        isFirst && 'is-first'
      } ${className}`}
    >
      <div className={`${CLASSNAME_PREFIX}`}>
        {heading && (
          <div
            role="button"
            tabIndex={0}
            onClick={() => setIsContentOpen(!isContentOpen)}
            onKeyDown={() => {}}
            aria-label={`${heading}-section-header`}
          >
            <LayoutSectionHeader
              isOpen={isContentOpen}
              isCollapsible={isCollapsible}
            >
              {heading}
            </LayoutSectionHeader>
          </div>
        )}
        {content && (
          <LayoutSectionContent
            isOpen={isContentOpen}
            isCollapsible={isCollapsible}
          >
            {content}
          </LayoutSectionContent>
        )}
      </div>
    </div>
  );
};

export default LayoutSection;
export { LayoutSectionHeader, LayoutSectionContent, LayoutSectionComponent };
